export const key = 'amp';
export const expiryKey = 'exp';
